import React from "react";

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/logo_for_white.svg`;

export interface CashierBrandLogoProps {
  className?: string;
  size?: number;
}

export const CashierBrandLogo: React.FC<CashierBrandLogoProps> = ({
  className,
  size = 28,
}) => (
  <img
    src={LOGO_SRC}
    alt="圆领"
    className={className}
    width={size}
    height={size}
    draggable={false}
  />
);
